import * as React from 'react';

import { cn } from '@/shared/utils/utils';

const badgeVariants = {
  default: 'border-transparent bg-primary/15 text-primary hover:bg-primary/20',
  secondary: 'border-transparent bg-muted text-muted-foreground hover:bg-accent',
  success: 'border-transparent bg-success/15 text-success hover:bg-success/20',
  destructive:
    'border-transparent bg-destructive/15 text-destructive hover:bg-destructive/20',
  outline: 'border-border text-foreground',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'success' | 'destructive' | 'outline';
}

function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-1 text-[11.5px] font-bold uppercase tracking-[0.03em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
        badgeVariants[variant],
        className
      )}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
